exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "social-security-header-employee{display:block;background-color:#eaebed;height:60px;width:100%;padding-top:20px;padding-left:80px;border:1px solid #eaebed;font-size:15px;font-family:Stag Sans}social-security-header-employee .data{display:inline-block;text-align:center;width:200px}social-security-header-employee .data span{color:#0072c9}social-security-header-employee span{color:#04408f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/social-security.module/components/socialSecurityHeaderEmployee/socialSecurityHeaderEmployee.scss
// module id = 2308
// module chunks = 0